import { render, staticRenderFns } from "./ship-in-label-sample.vue?vue&type=template&id=6ee7ee16&scoped=true"
import script from "./ship-in-label-sample.vue?vue&type=script&lang=js"
export * from "./ship-in-label-sample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee7ee16",
  null
  
)

export default component.exports